import {
  ControlWithDescription,
  InlineWithDescription,
} from 'components/form-layouts';

import { RffTextArea } from '@cast/shared-rff-ui';

export const SshKeySection = () => (
  <InlineWithDescription
    description={
      <ControlWithDescription label="SSH public key">
        Provide a public key to enable SSH access to provisioned nodes.
      </ControlWithDescription>
    }
    controls={
      <RffTextArea
        testId="ssh-public-key-text-area"
        rows={3}
        name="sshPublicKey"
        placeholder="e.g. ssh-ed25519 AAAAC3NzaC1lZDI1NTE5AAAA..."
      />
    }
  />
);
